import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';
const FormConfigurationContext = createContext({});
const FormConfigurationProvider = _ref => {
  let {
    enable,
    disableValidationParamName = "disableValidation",
    children
  } = _ref;
  return /* @__PURE__ */jsx(FormConfigurationContext.Provider, {
    value: {
      enable,
      disableValidationParamName
    },
    children
  });
};
export { FormConfigurationContext, FormConfigurationProvider as default };